import { NotFoundPage } from "./NotFoundPage";

export default NotFoundPageimport { NotFoundPage } from "./NotFoundPage";

export default NotFoundPage